import { render, staticRenderFns } from "./local-rbl.vue?vue&type=template&id=1aff8bda&"
import script from "./local-rbl.vue?vue&type=script&lang=js&"
export * from "./local-rbl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports